import { useEffect, useState } from "react";
import { DatepickerRange } from "../../utils/daterange";
import { LoadingButton } from "@mui/lab";
import { sendServerRequest } from "../../server/request";
import { URLS } from "../../env/urls";
import { serverRequestError } from "../utils/checkservererror";
import { TableWithSearchAndSortEngine } from "../utils/table";
import { formatLocalCurrency } from "../../utils/currency";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { CircularLoading } from "../utils/loading";


export function CltBotPropotalSupport(){
    const [loading,setLoading]=useState(false);
    const [startDate,setStartDate]=useState<Date>(new Date());
    const [endDate,setEndDate]=useState<Date>(new Date());
    const [propostals,setPropostals]=useState([]);
    const [dialogData,setDialogData]=useState();
    const [loadingComissioned,setLoadingComissioned]=useState<boolean|{id:number}>(false);
    useEffect(()=>{
       if(!loading)return;
       sendServerRequest('POST',URLS.clt.botPropostals,{
         from:startDate,
         to:endDate
       }).then(e=>{
          const props=e.data.data.propostals;
          setPropostals(props);
          setLoading(false);
       }).catch(e=>{
          serverRequestError(e);
          setLoading(false);
       })
    },[loading]);
    useEffect(()=>{
       if(!loadingComissioned)return;
       if(typeof(loadingComissioned)=='object'){
          const id=loadingComissioned.id;
          sendServerRequest('POST',URLS.clt.setSupport+'/'+id).then(e=>{
              setLoading(true);
              setDialogData(loadingComissioned as any);
              setLoadingComissioned(false);
              
          }).catch(e=>{
              serverRequestError(e);
              setLoadingComissioned(false);
          });
       }
    },[loadingComissioned]);
    return (<div>
        <PropostalComplete close={()=>setDialogData(undefined)} open={Boolean(dialogData)} data={dialogData}/>
        <DatepickerRange disabled={loading||Boolean(loadingComissioned)} title="Período de consulta." onUpdated={(s,e)=>{
             setStartDate(s);
             setEndDate(e);
        }}/>

        <LoadingButton loading={loading||Boolean(loadingComissioned)} onClick={()=>setLoading(true)} sx={{marginTop:'15px'}} variant="contained">Buscar Propostas</LoadingButton>
        <TableWithSearchAndSortEngine
          items={propostals}
          header={[
           {
            label:'Comissionado',
            id:'isComissioned',
            showValue:(e)=>{return e.isComissioned?'SIM':'NÃO'},
           } ,
           {
            label:'CPF',
            id:'cpf',
          },
          {
            label:'Status',
            id:'status'
          },{
            label:'Valor',
            id:'liquid_value',
            showValue:(e)=>{
         
                return formatLocalCurrency(e.liquid_value/100)},
          },{
            label:'Ação',
            id:'action',
            allowSort:false,
            showValue:(e)=>{
                  console.log(e);
                 const buttonText=e.isUser?'Ver Mais':
                 e.isComissioned?'Comissionar':'Não Permitido'
                 return <LoadingButton loading={Boolean(loadingComissioned)} 
                 onClick={()=>{
                     if(e.isComissioned&&!e.isUser){
                        setLoadingComissioned(e);
                        return;
                     }
                     if(e.isUser){
                        setDialogData(e);
                     }
                 }}
                 disabled={!e.isComissioned&&!e.isUser} variant="contained">
                       {buttonText}
                 </LoadingButton>
            }
          }]}

        />
    </div>)
}


function PropostalComplete({open,data,close}:{open:boolean,data:any,close:Function}){
    const [serverData,setServerData]=useState<undefined|null|{
        cpf: string
        liquidValue: number
        link: string
        installments: number
        name: string
        motherName: string
        birthDate: string
        status: string
        phone: string
        installmentValue: number
        firstDueDate: string
    }>();
    const [loading,setLoading]=useState(false);
    useEffect(()=>{
       if(!data){
          setServerData(null);
          return;
       }
       setLoading(true);
    },[data]);
    useEffect(()=>{
       if(!loading)return;
       sendServerRequest('POST',URLS.clt.botPropostal+'/'+data.id).then(e=>{
           const propostal=e.data.data.propostal;
           setServerData(propostal);
           setLoading(false);
       }).catch(e=>{
           serverRequestError(e);
           setLoading(false);
       })
    },[loading]);
    useEffect(()=>{
       if(!open){
          setServerData(null);
          return;
       }
    },[open]);
    return (<Dialog open={open}>
         <DialogTitle>{loading?'Carregando Proposta':serverData?.name}</DialogTitle>
         <DialogContent>
             {loading ? (
  <CircularLoading />
) : (
  <div>
    <ul>
      <li>Nome: {serverData?.name}</li>
      <li>CPF: {serverData?.cpf}</li>
      <li>Telefone: {serverData?.phone}</li>
      <li>Status: {serverData?.status}</li>
      <li>Valor líquido: {(serverData?.liquidValue||0)/100}</li>
      <li>Parcelas: {serverData?.installments}</li>
      <li>Valor da parcela: {serverData?.installmentValue}</li>
      <li>Primeiro vencimento: {serverData?.firstDueDate}</li>
      <li>Nome da mãe: {serverData?.motherName}</li>
      <li>Data de nascimento: {serverData?.birthDate}</li>
      <li style={{marginTop:'20px',marginBottom:'20px'}}>Link Proposta: {serverData?.link}</li>
    </ul>
  </div>
)}
         </DialogContent>
         <DialogActions>
            <LoadingButton onClick={()=>close()} variant="contained" loading={loading}>Sair</LoadingButton>
         </DialogActions>
    </Dialog>)
}

